import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#FFF",
  transform: "translate(4 4)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "8",
  cy: "8",
  r: "10",
  fill: "#F66",
  strokeWidth: "4"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2",
  d: "M5.5 5.5l4.95 4.95m0-4.95L5.5 10.45"
}));
var FileErrorIcon = function FileErrorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), _ref);
};
export default FileErrorIcon;